import { apiEndpointBase } from "./endpoint.config";

const base = apiEndpointBase;

export default {
  searchInCommunity: (communityId, query = "") =>
    base + `mentions/search-community/${communityId}?query=${query}`,
};
